export default __webpack_public_path__ + "static/media/delete.3a3bec42.svg";